import React, { useState } from 'react';
import { translate } from '../Services/translation';
import Squeezebox from './Squeezebox';

const StockStatus = ({ data, deliveryInformation }) => {
    const [showDescription, setShowDescription] = useState(false);

    return (
        <div className="stock-info__container">
            <div    
                className={`${data.onlyInStore ? "delivery-status-onlystore " :  (`delivery-status ${showDescription ? "is-open" : ""}`)}`}
                title={data.hoverText} 
                onClick={() => data.isCheckout ? null : setShowDescription(!showDescription)}
            >
                {data.color && <span className="delivery-status__icon" style={{ backgroundColor: data.color }}></span>}
                <span className="delivery-status__name">{data.text}</span>
                <span>{data.hoverText}</span>
            </div>
            {!data.isCheckout && !data.onlyInStore && <>
                {showDescription && <div className="squeezebox__html" dangerouslySetInnerHTML={{ __html: data.description }}></div>}
                {deliveryInformation && <div>
                    <Squeezebox title={deliveryInformation.deliveryText} html={deliveryInformation?.deliveryDescription}></Squeezebox>
                </div>}
                <div>
                    <Squeezebox title={translate("product.returninformation")} html={data.returnInformation} isOpen={true}></Squeezebox>
                </div>
                {data.onDisplayText && (
                    <p 
                        className={`product-on-display ${ 
                        (data.onDisplayText === translate("warehousesimilarproductdisplayedinstore") || 
                        data.onDisplayText === translate("warehouseproductdisplayedinstore"))  ? 'store-icon' : 'dot'
                    }`}
                    >
                        {data.onDisplayText}
                    </p>
                )}
            </>
            }
        </div>
    )
}


export default StockStatus;